import React, { Component } from 'react';
import Media from 'react-media';
import DatePicker, { registerLocale } from "react-datepicker";
import {Grid,TextField,Typography,Divider} from '@material-ui/core';

import pt from "date-fns/locale/pt";
registerLocale("pt", pt);
import "react-datepicker/dist/react-datepicker.css";

//css
import SectionCss from './Section-css';
const useStyles = SectionCss();

function atualizaCampos(campo,valor,props) {
    var newItens = props.state.itens;
    newItens[campo] = valor;
    props.setState({
        itens: newItens
    });
}

function atualizaData(data,props,campo) {
    var result = null;
    if (data !== null)
        result = data.toISOString();
    var newItens = props.state.itens;
    newItens[campo] = result;
    props.setState({
        itens: newItens
    });
}

function TelaMobile(props) {
    const classes = useStyles();
    return (
        <div className={'container'}>
            <div className={classes.mobile}>
                    <TextField variant={"filled"}
                        id="tf_nome"
                        label="Nome"
                        className={classes.textField}
                        value={props.state.itens.nome}
                        onChange={(e)=>{atualizaCampos('nome',e.target.value,props)}}
                        margin="normal"
                    />
                    <br/><br/>
                    <label className={classes.label}>Data Emissão</label>
                    <DatePicker
                        id="tf_data_emissao"
                        value={new Date(props.state.itens.data_emissao)}
                        onChange={(data) => {atualizaData(data,props,'data_emissao')}}
                        selected={new Date(props.state.itens.data_emissao)}
                        dateFormat="dd/MM/yyyy"
                        locale="pt"
                    />
                    <br/><br/>
                    <label className={classes.label}>Data Entrega Ideal</label>
                    <DatePicker
                        id="tf_data_entrega_ideal"
                        value={new Date(props.state.itens.data_entrega_ideal)}
                        onChange={(data) => {atualizaData(data,props,'data_entrega_ideal')}}
                        selected={new Date(props.state.itens.data_entrega_ideal)}
                        dateFormat="dd/MM/yyyy"
                        locale="pt"
                    />
                    <br/><br/>
                    <label className={classes.label}>Data Agendada</label>
                    <DatePicker
                        id="tf_data_agendada"
                        value={(props.state.itens.data_agendada?new Date(props.state.itens.data_agendada):'')}
                        onChange={(data) => {atualizaData(data,props,'data_agendada')}}
                        placeholderText="Agendar um dia"
                        selected={(props.state.itens.data_agendada?new Date(props.state.itens.data_agendada):'')}
                        dateFormat="dd/MM/yyyy"
                        excludeDates={props.state.dataAgendamentos}
                        locale="pt"
                    />
                    <br/><br/>
                    <TextField variant={"filled"}
                        id="tf_alpha"
                        label="Alpha"
                        className={classes.textField}
                        value={props.state.itens.alpha}
                        onChange={(e)=>{atualizaCampos('alpha',e.target.value,props)}}
                        margin="normal"
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_referencia"
                        label="Referência"
                        className={classes.textField}
                        value={props.state.itens.referencia}
                        onChange={(e)=>{atualizaCampos('referencia',e.target.value,props)}}
                        margin="normal"
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_ipi"
                        label="IPI"
                        className={classes.textField}
                        value={props.state.itens.ipi}
                        onChange={(e)=>{atualizaCampos('ipi',e.target.value,props)}}
                        margin="normal"
                        type={'number'}
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_prazo_pagamento"
                        label="Prazo Pagamento"
                        className={classes.textField}
                        value={props.state.itens.prazo_pagamento}
                        onChange={(e)=>{atualizaCampos('prazo_pagamento',e.target.value,props)}}
                        margin="normal"
                        type={'number'}
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_filial_entrega"
                        label="Filial Entrega"
                        className={classes.textField}
                        value={props.state.itens.filial_entrega}
                        onChange={(e)=>{atualizaCampos('filial_entrega',e.target.value,props)}}
                        margin="normal"
                        type={'number'}
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_pedido"
                        label="Pedido"
                        className={classes.textField}
                        value={props.state.itens.pedido}
                        onChange={(e)=>{atualizaCampos('pedido',e.target.value,props)}}
                        margin="normal"
                        type={'number'}
                    />
                    <br/>
                    <TextField variant={"filled"}
                        id="tf_tipo"
                        label="Tipo"
                        className={classes.textField}
                        value={props.state.itens.tipo}
                        onChange={(e)=>{atualizaCampos('tipo',e.target.value,props)}}
                        margin="normal"
                    />
            </div>
        </div>
    );
}

function TelaDesktop(props) {
    const classes = useStyles();
    
    return (
        <div className={'container'}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField variant={"filled"}
                            id="tf_nome"
                            label="Nome"
                            className={classes.textField}
                            value={props.state.itens.nome}
                            onChange={(e)=>{atualizaCampos('nome',e.target.value,props)}}
                            margin="normal"
                        />
                    </Grid>
                    <br/>
                    <Grid item xs={4}>
                        <label className={classes.label}>Data Emissão</label>
                        <DatePicker
                            id="tf_data_emissao"
                            value={new Date(props.state.itens.data_emissao)}
                            onChange={(data) => {atualizaData(data,props,'data_emissao')}}
                            selected={new Date(props.state.itens.data_emissao)}
                            dateFormat="dd/MM/yyyy"
                            locale="pt"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <label className={classes.label}>Data Entrega Ideal</label>
                        <DatePicker
                            id="tf_data_entrega_ideal"
                            value={new Date(props.state.itens.data_entrega_ideal)}
                            onChange={(data) => {atualizaData(data,props,'data_entrega_ideal')}}
                            selected={new Date(props.state.itens.data_entrega_ideal)}
                            dateFormat="dd/MM/yyyy"
                            locale="pt"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <label className={classes.label}>Data Agendada</label>
                        <DatePicker
                            id="tf_data_agendada"
                            value={(props.state.itens.data_agendada?new Date(props.state.itens.data_agendada):'')}
                            onChange={(data) => {atualizaData(data,props,'data_agendada')}}
                            placeholderText="Agendar um dia"
                            selected={(props.state.itens.data_agendada?new Date(props.state.itens.data_agendada):'')}
                            dateFormat="dd/MM/yyyy"
                            excludeDates={props.state.dataAgendamentos}
                            locale="pt"
                        />
                    </Grid>
                    <br/>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_alpha"
                            label="Alpha"
                            className={classes.textField}
                            value={props.state.itens.alpha}
                            onChange={(e)=>{atualizaCampos('alpha',e.target.value,props)}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_referencia"
                            label="Referência"
                            className={classes.textField}
                            value={props.state.itens.referencia}
                            onChange={(e)=>{atualizaCampos('referencia',e.target.value,props)}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_ipi"
                            label="IPI"
                            className={classes.textField}
                            value={props.state.itens.ipi}
                            onChange={(e)=>{atualizaCampos('ipi',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_prazo_pagamento"
                            label="Prazo Pagamento"
                            className={classes.textField}
                            value={props.state.itens.prazo_pagamento}
                            onChange={(e)=>{atualizaCampos('prazo_pagamento',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <br/>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_filial_entrega"
                            label="Filial Entrega"
                            className={classes.textField}
                            value={props.state.itens.filial_entrega}
                            onChange={(e)=>{atualizaCampos('filial_entrega',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_pedido"
                            label="Pedido"
                            className={classes.textField}
                            value={props.state.itens.pedido}
                            onChange={(e)=>{atualizaCampos('pedido',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_tipo"
                            label="Tipo"
                            className={classes.textField}
                            value={props.state.itens.tipo}
                            onChange={(e)=>{atualizaCampos('tipo',e.target.value,props)}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_quantidade"
                            label="Quantidade"
                            className={classes.textField}
                            value={props.state.itens.quantidade}
                            onChange={(e)=>{atualizaCampos('quantidade',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <br/>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_estoque_disponivel"
                            label="Estoque disponível"
                            className={classes.textField}
                            value={props.state.itens.estoque_disponivel}
                            onChange={(e)=>{atualizaCampos('estoque_disponivel',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_indice_qualidade"
                            label="Índice qualidade"
                            className={classes.textField}
                            value={props.state.itens.indice_qualidade}
                            onChange={(e)=>{atualizaCampos('indice_qualidade',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_rotacao_ponderada"
                            label="Rotação ponderada"
                            className={classes.textField}
                            value={props.state.itens.rotacao_ponderada}
                            onChange={(e)=>{atualizaCampos('rotacao_ponderada',e.target.value,props)}}
                            margin="normal"
                            type={'number'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField variant={"filled"}
                            id="tf_ruptura"
                            label="Ruptura"
                            className={classes.textField}
                            value={props.state.itens.ruptura}
                            onChange={(e)=>{atualizaCampos('ruptura',e.target.value,props)}}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
            <br/>
        </div>
    );
}

function SectionForm(props) {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <div>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Pedido #{props.state.codigo}
                </Typography>
                <Divider style={{backgroundColor:'gray'}} />
            </div>
            <br/>
            <Media query="(min-width: 1200px)">
                {matches =>
                    matches ? (
                        <TelaDesktop {...props}/>
                    ) : (
                        <TelaMobile {...props}/>
                    )
                }
            </Media>
        </div>
    );
}

export default class Section extends Component {

    constructor(props) {
        super(props);

        var data = this.props.props.pai.state.itens[this.props.state.id];

        this.state = {
            itens: data,
            dataAgendamentos: this.props.props.pai.state.dataAgendamentos
        };
        
        this.setState = this.setState.bind(this);
        
    }

    render() {
        return(<SectionForm {...this}/>);
    }

};